import React from 'react';
import { compose } from 'ramda';
import { validateAsyncComponent } from '../../HoC/index.js';
import { connect } from 'react-redux';
import TimeoutModalStandar from './Standar.jsx';
import TimeoutModalEurostars from './Eurostarshotels.jsx';

const idBtns = (step) => {
    let idBtnsModal = {
        idCloseIcon: 'td-d0-close-inactivity-00',
        idContinueBtn: 'td-d0-close-inactivity-01'
    };
    switch (step) {
        case 'monoHotelAvail':
            idBtnsModal.idCloseIcon = 'td-d1-close-inactivity-00';
            idBtnsModal.idContinueBtn = 'td-d1-close-inactivity-01';
        break;
        case 'serviceHotelAvail':
            idBtnsModal.idCloseIcon = 'td-d2-close-inactivity-00';
            idBtnsModal.idContinueBtn = 'td-d2-close-inactivity-01';
        break;
        case 'customerForm':
            idBtnsModal.idCloseIcon = 'td-d3-close-inactivity-00';
            idBtnsModal.idContinueBtn = 'td-d3-close-inactivity-01';
        break;
        default:
        break;
    }
    return idBtnsModal;
};

const TimeoutModal = props => {
    const { isEurostars, currentStep } = props;
    const reload = window.location.reload.bind(window.location)
    if (isEurostars) {
        return (<TimeoutModalEurostars {...props} reload={reload} idBtnsModal={idBtns(currentStep)}/>)
    } else {
        return (<TimeoutModalStandar {...props} reload={reload} idBtnsModal={idBtns(currentStep)}/>)
    }
}

const mapStateToProps = (store, ownProps) => {
    const hotelId = store.getIn(['customer', 'current_hotel']);
    const hotelInfo = store.getIn(['hotels', hotelId], null);
    const isEurostars = store.get("group") === "eurostarshotels"
    const url_params = store.getIn(['customer','params','url_params']);
    const currentStep = store.getIn(['customer', 'step', 'current_step', 'code']);
    let preReservation = null;
    if(url_params){
        preReservation = {
            checkin: url_params.get('start'),
            checkout: url_params.get('end'),
            occups: url_params.get('occups'),
            idCity: url_params.get('city_id'),
            idCountry: url_params.get('country_id'),
            corporate: store.getIn(['customer','corporate'])
        };
    }
    return {
        hotelsNumber: store.getIn(['hotels']).keySeq().filter(key => key !== 'hotels_info').count(),
        hotelInfo: hotelInfo,
        currentStep: currentStep,
        isEurostars: isEurostars,
        reservation: store.getIn(['customer', 'reservation']),
        corporateInfo: store.getIn(['customer','corporate']),
        preReservation: preReservation
    };
};
TimeoutModal.displayName = "TimeoutModal";
export default compose(
    connect(mapStateToProps),
    validateAsyncComponent(mapStateToProps)
)(TimeoutModal);